// Session management utilities for Next.js

/**
 * Simple UUID v4 generator
 */
function generateUUID(): string {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

/**
 * Initialize a new session or return existing session ID
 */
export function initializeSession(): string {
    if (typeof window === "undefined") {
        return "ssr-session"; // Temporary ID for SSR
    }

    const sessionId = sessionStorage.getItem("session_id") || generateUUID();
    sessionStorage.setItem("session_id", sessionId);
    return sessionId;
}

/**
 * Get the current session ID
 */
export function getSessionId(): string {
    if (typeof window === "undefined") {
        return "ssr-session";
    }
    return sessionStorage.getItem("session_id") || initializeSession();
}

/**
 * Clear the current session
 */
export function clearSession(): void {
    if (typeof window !== "undefined") {
        sessionStorage.removeItem("session_id");
    }
}